import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Algorithm = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M10.5,2v2M13.5,2v2M8,6.5h-2M8,9.5h-2M18,6.5h-2M18,9.5h-2M13.33,4h-2.67c-1.26,0-1.89,0-2.28.39-.39.39-.39,1.02-.39,2.28v2.67c0,1.26,0,1.89.39,2.28.39.39,1.02.39,2.28.39h2.67c1.26,0,1.89,0,2.28-.39s.39-1.02.39-2.28v-2.67c0-1.26,0-1.89-.39-2.28-.39-.39-1.02-.39-2.28-.39Z" />
        <path d="M3.62,21.92c.18.08.42.08.88.08s.7,0,.88-.08c.25-.1.44-.3.54-.54.08-.18.08-.42.08-.88s0-.7-.08-.88c-.1-.25-.3-.44-.54-.54-.18-.08-.42-.08-.88-.08s-.7,0-.88.08c-.25.1-.44.3-.54.54-.08.18-.08.42-.08.88s0,.7.08.88c.1.25.3.44.54.54Z" />
        <path d="M11.12,21.92c.18.08.42.08.88.08s.7,0,.88-.08c.24-.1.44-.3.54-.54.08-.18.08-.42.08-.88s0-.7-.08-.88c-.1-.25-.3-.44-.54-.54-.18-.08-.42-.08-.88-.08s-.7,0-.88.08c-.24.1-.44.3-.54.54-.08.18-.08.42-.08.88s0,.7.08.88c.1.25.3.44.54.54Z" />
        <path d="M12,19v-7" />
        <path
          fill="none"
          d="M4.5,19c0-1.4,0-2.11.34-2.61.15-.22.33-.41.55-.55.5-.34,1.21-.34,2.61-.34h8c1.4,0,2.11,0,2.61.34.22.15.41.33.55.55.34.5.34,1.21.34,2.61"
        />
        <path d="M18.62,21.92c.18.08.42.08.88.08s.7,0,.88-.08c.25-.1.44-.3.54-.54.08-.18.08-.42.08-.88s0-.7-.08-.88c-.1-.25-.3-.44-.54-.54-.18-.08-.42-.08-.88-.08s-.7,0-.88.08c-.25.1-.44.3-.54.54-.08.18-.08.42-.08.88s0,.7.08.88c.1.25.3.44.54.54Z" />
      </svg>
    );
  },
);

export default Algorithm;
